import { Button, Heading, VStack, Text, useColorModeValue, Box, Flex, Container } from "@chakra-ui/react";
import React, { useContext } from "react";
import Select from "react-select";
import { AppContext } from "../context/AppContext";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import Boy from "./Boy";

const SelectService = ({ server = 'server1' }) => {
  const { isDark, servicesData1, setServiceService, servicesData2, servicesData3, servicesData4, servicesData5 } =
    useContext(AppContext);
  const navigate = useNavigate();

  const handleChange = (event) => {
    setServiceService({ service: event.label, code: event.value, server: event.server });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    navigate("/getotp");
  };

  // Premium UI Colors
  const bg = useColorModeValue("gray.50", "gray.900");
  const cardBg = useColorModeValue("rgba(255, 255, 255, 0.8)", "rgba(26, 32, 44, 0.6)");
  const cardBorder = useColorModeValue("white", "gray.700");
  const textColor = useColorModeValue("gray.800", "white");
  const shadow = useColorModeValue("0 8px 32px 0 rgba(31, 38, 135, 0.15)", "0 8px 32px 0 rgba(0, 0, 0, 0.37)");
  const borderColor = useColorModeValue('#E2E8F0', '#4A5568');
  let options;

  if (server === 'server1') {
    options = servicesData5;
  } else if (server === 'server2') {
    options = servicesData3;
  } else if (server === 'server3') {
    options = servicesData1;
  } else if (server === 'server4') {
    options = servicesData2;
  } else if (server === 'server5') {
    options = servicesData4
  }

  return (
    <>
      <Helmet>
        <title>Dashboard | Techy India</title>
      </Helmet>

      <Flex
        minH="86vh"
        w="100%"
        bg={bg}
        align="start"
        justify="center"
        p={{ base: 4, md: 6, lg: 10, xl: 16 }}
        direction={{ base: "column", lg: "row" }}
        gap={{ base: 8, lg: 10, xl: 14 }}
        maxW={{ lg: "1200px" }}
        mx="auto"
      >
        {/* Left Side: Form Card */}
        <Box
          w={{ base: "100%", lg: "480px", xl: "520px" }}
          flex={{ lg: "0 0 auto" }}
          bg={cardBg}
          backdropFilter="blur(12px)"
          border="1px solid"
          borderColor={cardBorder}
          borderRadius="2xl"
          boxShadow={shadow}
          p={{ base: 6, md: 8, lg: 10 }}
          position="relative"
        >
          {/* Decorative Top Line */}
          <Box
            position="absolute"
            top="0"
            left="0"
            w="100%"
            h="4px"
            bgGradient="linear(to-r, brand.400, brand.600)"
          />

          <VStack spacing={8} align="stretch">
            <VStack spacing={2} align="center">
              <Heading
                fontSize={{ base: "2xl", md: "3xl" }}
                color={textColor}
                fontWeight="800"
                letterSpacing="-0.5px"
              >
                Select <Text as="span" color="brand.500">Service</Text>
              </Heading>
              <Text color="gray.500" fontSize="sm" textAlign="center">
                Choose from our wide range of services
              </Text>
            </VStack>


            <form onSubmit={handleSubmit} style={{ width: "100%" }}>
              <VStack spacing={6}>
                <Box w="100%">
                  <Select
                    onChange={handleChange}
                    required={true}
                    options={options}
                    placeholder="Search service..."
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        borderColor: state.isFocused ? '#319795' : borderColor,
                        padding: '0.4rem',
                        borderRadius: '12px',
                        backgroundColor: isDark ? '#2D3748' : 'white',
                        color: isDark ? 'white' : 'black',
                        boxShadow: state.isFocused ? '0 0 0 1px #319795' : 'none',
                        '&:hover': {
                          borderColor: '#319795'
                        }
                      }),
                      menu: (base) => ({
                        ...base,
                        backgroundColor: isDark ? '#2D3748' : 'white',
                        zIndex: 9999,
                        borderRadius: '12px',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                        padding: '8px'
                      }),
                      option: (base, state) => ({
                        ...base,
                        backgroundColor: state.isFocused ? (isDark ? '#4A5568' : '#E6FFFA') : (isDark ? '#2D3748' : 'white'),
                        color: isDark ? 'white' : 'black',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        marginBottom: '2px'
                      }),
                      singleValue: (base) => ({
                        ...base,
                        color: isDark ? 'white' : 'black',
                        fontWeight: '500'
                      }),
                      input: (base) => ({
                        ...base,
                        color: isDark ? 'white' : 'black',
                      }),
                      placeholder: (base) => ({
                        ...base,
                        color: isDark ? 'gray.400' : 'gray.500',
                      })
                    }}
                  />
                </Box>

                <Button
                  type="submit"
                  w="100%"
                  h="3.2rem"
                  fontSize="1.1rem"
                  fontWeight="bold"
                  color="white"
                  bgGradient="linear(to-r, brand.400, brand.600)"
                  rounded="xl"
                  shadow="lg"
                  _hover={{
                    bgGradient: "linear(to-r, brand.500, brand.700)",
                    transform: "translateY(-2px)",
                    shadow: "xl"
                  }}
                  _active={{
                    transform: "translateY(0)",
                  }}
                  transition="all 0.2s"
                >
                  Proceed Next
                </Button>
              </VStack>
            </form>
          </VStack>
        </Box>

        {/* Right Side: Illustration */}
        <Box
          display={{ base: "flex", lg: "flex" }}
          justifyContent="center"
          alignItems="center"
          flex={{ lg: "1" }}
          w={{ base: "100%", md: "75%", lg: "auto" }}
          maxW={{ base: "420px", lg: "560px" }}
        >
          <Boy />
        </Box>
      </Flex>
    </>
  );
};

export default SelectService;
